module.exports = __webpack_public_path__ + "static/media/Sleeping.4f463021.svg";